<ng-sidebar-container>
  <div ng-sidebar-content>
    <ngx-page-container>
      <h1>Offers</h1>
      <hr>


      <div style="margin-left:1em;min-width:35em" *ngIf="search">
        <label><b>Filter</b></label>
        <div class="row ml-1">
          <div style="width:25em">
            <ngx-doc-form-multiselect [(value)]="filter.issuer" [options]="issuerOptions" [multi]="false" placeholder="Select Issuer(s)"></ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect [(value)]="filter.country" [options]="countryOptions" placeholder="Select Country"></ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect [(value)]="filter.manager" [options]="employeeOptions" [multi]="false" placeholder="Select Manager"></ngx-doc-form-multiselect>
          </div>
          <div style="width: 42em">
            <ngx-doc-form-multiselect [(value)]="filter.customers" [options]="data.businessOptions" (valueChange)="customersChanged($event)"
              [checkbox]="true" [maxSelectedItems]="3" placeholder="Select customer(s)">
            </ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect *ngIf="filter.customers?.length" [(value)]="filter.customerDocumentNumbers" [checkbox]="true"
              [options]="customerReferenceOptions" placeholder="Customer reference(s)">
            </ngx-doc-form-multiselect>

            <ngx-doc-form-multiselect *ngIf="filter.businessUnits" [(value)]="filter.businessUnits" [options]="data.businessUnitOptions"
              [checkbox]="true" placeholder="Select business unit(s)">
            </ngx-doc-form-multiselect>
          </div>
        </div>

        <div class="mt-4" style="max-width:57em">
          <ngx-form-multi-select [checkbox]="true" title="Select Finished Products" [businessId]="finishedProductBusinessId" [mode]="'column-select'" [(value)]="filter.finishedProducts" [options]="data.finishedProductOptions">
          </ngx-form-multi-select>
        </div>

        <div class="row mt-3">
          <div class="col-md-4">Offer status</div>
          <div class="col-md-8">
            <div class="checkbox row col-md-12" style="position:relative;left:-12rem">
              <label *ngFor="let status of offerStati; let idx = index" class="mr-3"><input type="checkbox" [(ngModel)]="search.offers.offerStatus[idx]">&nbsp;{{status.name}}</label>
            </div>
          </div>
        </div>
        
        <!-- <div class="row mt-3">
          <div class="col-md-4">Sort by</div>
          <div class="col-md-8">
            <nb-radio-group name="businessStatus" [(ngModel)]="filter.sortOrder" style="display:inline-flex">
              <nb-radio [value]="undefined">default</nb-radio>
              <nb-radio [value]="10">Display New Business First</nb-radio>
              <nb-radio [value]="11">Display Active Business First</nb-radio>
            </nb-radio-group>
          </div>
        </div> -->
        
      </div>

      <br>
      <div>
        <button class="btn btn-info btn-lg" (click)="reload()">Apply Filter</button>
        <button class="ml-4 btn btn-info btn-lg" (click)="reload(true)">Alternate View (SM)</button>
      </div>
      <br>

      <ngx-reports-printer #reportsPrinter [search]="search" [pdfSidebar]="true" [printCount]="true" [messaging]="true" [noheader]="true" (done)="reportLoaded()"></ngx-reports-printer>

    </ngx-page-container>
  </div>
</ng-sidebar-container>

